import { getLogger } from 'app-components/utils/core';

import type { ToolHandler, ToolMessage, ToolResponse } from './llmToolsTypes';

const log = getLogger('llmToolsFramework');

export const wrapHandler = (name: string, handler: ToolHandler): ToolHandler => {
  return async (msg: ToolMessage) => {
    log.debug(`Tool called: ${name}`, { args: msg.arguments });
    const startTime = Date.now();

    try {
      const res = await handler(msg); // call once
      const duration = Date.now() - startTime;
      log.debug(`Tool completed: ${name} (${duration}ms)`);
      return res; // 🔑 return it
    } catch (error) {
      const duration = Date.now() - startTime;
      log.error(`Tool failed: ${name} (${duration}ms)`, error);

      // Either return a synthetic error response...
      const errorResponse: ToolResponse = {
        callId: msg.callId,
        type: 'response.function_call.output.done',
        name: msg.name,
        output: `Error executing tool: ${error instanceof Error ? error.message : 'Unknown error'}`,
      };
      return errorResponse; // 🔑 return it
    }
  };
};

export const returnToolResponse = <T = any>(msg: ToolMessage, output: T): ToolResponse<T> => {
  log.debug('Tool Response Output', output);
  return {
    callId: msg.callId,
    type: 'response.function_call.output.done',
    name: msg.name,
    output,
  };
};
